<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Uw104O/tc-custom/9781466861077.jpg?1732160558896" alt="This image is the cover for the book Dog Who Spoke with Gods"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dog Who Spoke with Gods
      </h1>
      <p class="bookDescription body article font2">
        <p>When Elizabeth, a young pre-med. student happens upon Damien, a dog being used in laboratory research on her campus, she has no way of knowing how drastically her life - and her beliefs - will be changed. Without meaning to, she slowly becomes drawn into the dog's fate and is soon torn between the love and respect she has come to feel for Damien and the sense of loyalty and obligation she feels for the medical profession as well as her father and grandfather, both cardiac surgeons.<br/><br/>With an uncanny ability to write convincingly about life from the point of view of a canine, Diane Jessup tells an extraordinary story of friendship and loyalty in <i>The Dog Who Spoke with Gods</i>. Few writers have ever shown the world of man's closest friend as clearly and movingly. For anyone who has ever loved a dog this is a must-read.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Jessup
      </h2>
      
      <p class="authorDescription body article"><P><B>Diane Jessup</B> is the author of <I>The Working Pit Bull</I> and <I>Colby's Book of the American Pit Bull Terrier.</I> She lives in Olympia, Washington with her canine family.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Griffin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ed62644